const Dot = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="4" height="5" viewBox="0 0 4 5" fill="none">
        <circle cx="2" cy="2.625" r="2" fill="#D5E0E3"/>
    </svg>
}

export default Dot